import React from 'react';
import LoadingIndicator from '../../../components/shared/LoadingIndicator/LoadingIndicator';
import { WebsiteIndexEntry, UpdateWebsiteIndexEntrySettingsParams } from '../../../deepAnalysis/websiteIndexEntry/types';
import { useUpdateWebsiteIndexEntrySettingsMutation } from '../../../deepAnalysis/websiteIndexEntry/service';
import { useFetchMonitorRegionsQuery } from '../../../trackedWebsites/service';
import LocationsInput from './LocationsInput';
import useGetPlanSettings from '../../../sales/hooks/useGetPlanSettings';

type Props = {
    selectedWebsite: WebsiteIndexEntry;
};

export default function LocationTab({ selectedWebsite }: Props) {
    const { maxRegions } = useGetPlanSettings();
    const [updateSettings, { isLoading: isUpdatingTrackedWebsiteSettings }] = useUpdateWebsiteIndexEntrySettingsMutation();
    const { data: monitorRegionsData, isLoading: isLoadingMonitorRegions } = useFetchMonitorRegionsQuery();

    const handleUpdateLocations = async (args: UpdateWebsiteIndexEntrySettingsParams) => {
        try {
            await updateSettings(args).unwrap();
        } catch (error) { }
    };

    if (isLoadingMonitorRegions || !monitorRegionsData) {
        return <LoadingIndicator />;
    }

    return (
        <div className="location-tab">
            <LocationsInput
                key={selectedWebsite.guid}
                selectedWebsite={selectedWebsite}
                monitorRegions={monitorRegionsData.regions}
                monitorRegionsOrder={monitorRegionsData.order}
                maxRegions={maxRegions ? maxRegions : -1}
                isLoading={isUpdatingTrackedWebsiteSettings}
                onUpdateLocations={handleUpdateLocations}
            />
        </div>
    );
}
